export default "__VITE_ASSET__02821e08__"